import React, { useState } from "react";
import { Popover, Button, Typography, Paper, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  popoverPaper: {
    padding: theme.spacing(2),
    maxWidth: 300,
  }
}));

export default function ComponentsPopover() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "components-popover" : undefined;

  return (
    <div>
      <Button aria-describedby={id} variant="contained" color="secondary" onClick={handleClick}>
        Mostrar Popover de Exemplo
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Paper className={classes.popoverPaper}>
          <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>Exemplo de Popover</Typography>
          <Typography variant="body2" color="textSecondary">
            Esse é um componente de Popover flutuante usado na plataforma para exibir informações contextuais, 
            como o menu de chats ou as notificações.
          </Typography>
        </Paper>
      </Popover>
    </div>
  );
}